module.exports = __webpack_public_path__ + "img/TH_norms_img.782cd8bc.png";